export const ROUTES = {
    ROOT: '/',
    LOGIN: '/login',
    LOGIN_CALLBACK: '/login/callback',
    PROJECTS: '/projects',
    PROJECTS_NEW: '/projects/new',
    PROJECT_DETAIL: '/projects/:id',
    PROJECT_QUOTE_NEW: '/projects/:id/quotes/new',
    ADMIN: '/admin',
    ADMIN_CUSTOMERS: '/admin/customers',
    ADMIN_VENDORS: '/admin/vendors',
    ADMIN_LANGUAGES: '/admin/languages',
    ADMIN_SERVICES: '/admin/services',
} as const;

/** Backend API paths. All API calls should reference these constants. */
export const API = {
    CUSTOMERS: '/api/v1/customers',
    VENDORS: '/api/v1/vendors',
    LANGUAGES: '/api/v1/languages',
    SERVICES: '/api/v1/services',
    PROFIT_CENTRES: '/api/v1/profit-centres',
    SUB_SERVICES: '/api/v1/sub-services',
    CUSTOMER_RATE_CARDS: '/api/v1/customer-rate-cards',
    USERS: '/api/v1/users',
    USER_NAMES: '/api/v1/user-names',
    PROJECTS: '/api/v1/projects',
    BACKSHEETS: '/api/v1/backsheets',
    QUOTES: '/api/v1/quotes',
    SYS_CONFIGS: '/api/v1/sys-configs',
    NOTES: '/api/v1/comments',
    ATTACHMENTS: '/api/v1/attachments',
    S3_PRESIGN_DOWNLOAD: '/api/v1/s3/presign/download',
    SETTINGS_SUPPORTED_CURRENCIES: '/api/v1/settings/supported-currencies',
    SETTINGS_CURRENCY_RATES: '/api/v1/settings/currency-rates',
    SETTINGS_CURRENCY_CSV: '/api/v1/settings/currency-rates/csv',
    COMMENTS: '/api/v1/comments',
    PROJECT_UPDATES: '/api/v1/project-updates',
    SERVICE_GROUPS: '/api/v1/service-groups',
    LINE_ITEMS: '/api/v1/service-group-line-items',
} as const;

export function projectDetailPath(id: string) {
    return `/projects/${id}`;
}

export function projectQuoteNewPath(id: string) {
    return `/projects/${id}/quotes/new`;
}
